import React, { Component } from 'react';
import axios from 'axios';

import { TextFieldFormsy, CheckboxFormsy, RadioGroupFormsy, SelectFormsy } from '@fuse';


class test extends React.Component {
    
}

// -IMAGE UPLOAD CODE CORRECT CODE-
// ===============================

// export default class test extends Component {

//     constructor(props) {
//         super(props);

//         this.state = {
//             imageURL: '',
//         };

//         this.handleUploadImage = this.handleUploadImage.bind(this);
//     }

//     handleUploadImage(ev) {
//         ev.preventDefault();

//         const data = new FormData();
//         data.append('file', this.uploadInput.files[0]);
//         data.append('filename', this.fileName.value);

//         fetch('http://localhost:3006/upload', {
//             method: 'POST',
//             body: data,
//         }).then((response) => {
//             response.json().then((body) => {
//                 this.setState({ imageURL: `http://localhost:3006/${body.file}` });
//             });
//         });
//     }

//     render() {
//         return (
//             <form onSubmit={this.handleUploadImage}>
//                 <div>
//                     <input ref={(ref) => { this.uploadInput = ref; }} type="file" />
//                 </div>
//                 <div>
//                     <input ref={(ref) => { this.fileName = ref; }} type="text" placeholder="Enter the desired name of file" />
//                 </div>
//                 <br />
//                 <div>
//                     <button>Upload</button>
//                 </div>
//                 <img src={this.state.imageURL} alt="img" />
//             </form>
//         );
//     }
// }

// import React, { Component } from 'react';
// import { Button, FormControlLabel, MenuItem, Radio, Typography } from 'material-ui';
// import { TextFieldFormsy, CheckboxFormsy, RadioGroupFormsy, SelectFormsy } from '@fuse';
// import Formsy from 'formsy-react';
// import IconButton from 'material-ui/IconButton';
// import PhotoCamera from '@material-ui/icons/PhotoCamera';
// import axios from 'axios';

// class test extends Component {
//     state = {
//         canSubmit: false
//     };

//     disableButton = () => {
//         this.setState({ canSubmit: false });
//     };

//     enableButton = () => {
//         this.setState({ canSubmit: true });
//     };

//     onSubmit = (model) => {

//         var photoObj = {
//             profileImg : model.profileImg
//         }

//         axios.post('http://localhost:3006/upload', photoObj)
//             .then(res => {

//                 alert(res.data.success);
//                 if (res.data.success) {

//                     alert("Success");
//                 } else {
//                     alert('Ivalid Credentials');
//                 }
//             })
//     };

//     render() {
//         const { canSubmit } = this.state;

//         return (
//             <div className="max-w-sm">
//                 <Typography className="h2 mb-24">Example Formsy Form</Typography>
//                 <Formsy
//                     onValidSubmit={this.onSubmit}
//                     onValid={this.enableButton}
//                     onInvalid={this.disableButton}
//                     ref={(form) => this.form = form}
//                     className="flex flex-col justify-center"
//                 >

//                     <TextFieldFormsy
//                         className="mb-24"
//                         type="text"
//                         name="name"
//                         label="Name"
//                     />

//                     <div className="w-full md:w-1/6 mt-12 relative">
//                         <div className="MuiAvatar-root-915 w-96 h-96 absolute w-full">
//                             <img id="profileImg" src="assets/images/avatars/katherine.jpg" className="MuiAvatar-img-917" />
//                         </div>

//                         <input accept="image/*" name="profileImg" className="{classes.input} " id="icon-button-file" type="file" />
//                         {/* <label htmlFor="icon-button-file">
//                             <IconButton color="primary" className="{classes.button} mt-64" component="span">
//                                 <PhotoCamera />
//                             </IconButton>
//                         </label> */}
//                     </div>

//                     <Button
//                         type="submit"
//                         variant="raised"
//                         color="primary"
//                         className="mx-auto mt-16"
//                     >
//                         Upload
//                     </Button>
//                 </Formsy>
//             </div>
//         );
//     }
// }

export default test;


// WEBPACK FOOTER //
// ./src/main/content/hr/testing/test.js